import React from 'react';
import PropTypes from 'prop-types';
import { BQLink } from '../../../../atoms/bqlink';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { contentClick } from '../../../../../helpers/datalayer-utils';
import './market-news-reaction-card.m.css';

const MarketNewsReactionCard = ({ newsItem }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const author = newsItem?.author_byline;
  return (
    <div styleName="wrapper" className="card-with-reaction-title">
      <div styleName="author-name">{author}</div>
      <div onClick={() => contentClick(userData, newsItem, pageType)}>
        <BQLink href={new URL(newsItem?.link).pathname}>
          <div styleName="headline">
            {newsItem?.title}
          </div>
        </BQLink>
      </div>
    </div>
  );
};

MarketNewsReactionCard.propTypes = {
  newsItem: PropTypes.object.isRequired,
};

export default MarketNewsReactionCard;
